import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_editor_toolbox = _resolveComponent("ui-editor-toolbox")!

  return ($setup.store.alignment)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_ui_editor_toolbox, {
          toolbox: $setup.showToolbox,
          "onUpdate:toolbox": _cache[3] || (_cache[3] = ($event: any) => (($setup.showToolbox) = $event)),
          disabledAnimation: ""
        }, {
          default: _withCtx(() => [
            _createVNode($setup["DatasetTree"], {
              list: $setup.list,
              selects: $setup.store.selectList,
              search: "",
              onSelects: _cache[0] || (_cache[0] = raws => ($setup.store.selectList = raws)),
              onSearch: _cache[1] || (_cache[1] = raw => ($setup.store.lightList = [raw])),
              highlight: $setup.store.lightList,
              onClick: _cache[2] || (_cache[2] = 
          raw => {
            ;($setup.store.selectList.includes(raw) ||
              (raw.type === 'label' && !raw.children?.length)) &&
              $setup.flyDataset(raw)
            $setup.pushLight(raw)
          }
        )
            }, {
              label: _withCtx(({ raw, icon }) => [
                _createVNode($setup["IconLabel"], {
                  raw: raw,
                  icon: icon,
                  onUpdateColor: color => (raw.origin.color = color)
                }, null, 8 /* PROPS */, ["raw", "icon", "onUpdateColor"])
              ]),
              prectrl: _withCtx(({ raw, select }) => [
                ($setup.isLocking(raw))
                  ? (_openBlock(), _createBlock(_component_ui_icon, {
                      key: 0,
                      type: "lock_n",
                      "tip-h": "right",
                      "tip-v": "bottom",
                      style: {"margin-left":"10px"}
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              ctrl: _withCtx(({ raw, select }) => [
                _createVNode(_component_ui_icon, {
                  type: "pin",
                  style: {"margin-left":"10px"},
                  tip: _ctx.$t('dataset.setting.viewCenter'),
                  class: _normalizeClass({
              notSelect: !(
                select ||
                (raw.type === 'label' && !raw.children?.length)
              )
            }),
                  ctrl: "",
                  onClick: _withModifiers(($event: any) => {
              ;(select || (raw.type === 'label' && !raw.children?.length)) &&
                $setup.flyDataset(raw)
            }, ["stop"])
                }, null, 8 /* PROPS */, ["tip", "class", "onClick"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["list", "selects", "highlight"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["toolbox"]),
        ($setup.store.alignment)
          ? (_openBlock(), _createBlock($setup["Control"], {
              key: 0,
              alignment: $setup.store.alignment,
              select: ($setup.store.lightList as any)
            }, null, 8 /* PROPS */, ["alignment", "select"]))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    : _createCommentVNode("v-if", true)
}